import WarningIcon from './component.jsx'
export default WarningIcon
